"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = require("styled-components"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var CloseIcon = function CloseIcon(_ref) {
  var size = _ref.size,
      color = _ref.color,
      theme = _ref.theme;
  var fillColor = color || theme.colorText;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: fillColor
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
  }));
};

CloseIcon.propTypes = {
  size: _propTypes.number,
  color: _propTypes.string,
  theme: _propTypes.object // provided by `withTheme`

};
CloseIcon.defaultProps = {
  size: 24,
  color: ''
};

var _default = (0, _styledComponents.withTheme)(CloseIcon);

exports["default"] = _default;